(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["community-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    function initGallery(el) {
      if (el.dataset.cgReady) return;
      var track = el.querySelector('[data-community-gallery-track]');
      if (!track) return;
      var row = track.querySelector('.community-gallery__row');
      if (!row) return;
      if (row.querySelectorAll('.shopify-block').length < 2) return;
      el.dataset.cgReady = 'true';
      var clone = row.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
      el.classList.add('is-animating');
    }
    function boot() {
      document.querySelectorAll('[data-community-gallery]').forEach(initGallery);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    function ctSelectTab(form, index) {
    const tabs = form.querySelectorAll('.ct-form__tab');
    const panels = form.querySelectorAll('.ct-form__panel');
    tabs.forEach((tab, i) => {
      const on = i === index;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
    });
    panels.forEach((panel, i) => panel.classList.toggle('is-active', i === index));
  }

  function ctBindForm(form) {
    if (form.dataset.ctBound) return;
    form.dataset.ctBound = 'true';
    const tabs = Array.from(form.querySelectorAll('.ct-form__tab'));
    if (!tabs.length) return;
    let initial = tabs.findIndex((tab) => tab.classList.contains('is-active'));
    if (initial < 0) initial = 0;
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => ctSelectTab(form, i));
    });
    ctSelectTab(form, initial);
  }

  function ctBootForms() {
    document.querySelectorAll('[data-ct-form]').forEach(ctBindForm);
  }

  if (document.readyState !== 'loading') {
    ctBootForms();
  } else {
    document.addEventListener('DOMContentLoaded', ctBootForms);
  }
  document.addEventListener('shopify:section:load', ctBootForms);
  document.addEventListener('shopify:block:select', ctBootForms);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["faq-categories"] && !Shopify.designMode) return;
  try {
    (function () {
    function initFaqCats(root) {
      if (root.dataset.wReady) return;
      root.dataset.wReady = 'true';

      var row = root.querySelector('.faq-cats__row');
      var scope = root.closest('.shopify-section') || document;
      var list = scope.querySelector('[data-accordion]');
      if (!row || !list) return;

      var items = Array.prototype.slice.call(list.querySelectorAll('[data-accordion-item]'));

      function flexChild(item) {
        var el = item;
        while (el.parentNode && el.parentNode !== list) el = el.parentNode;
        return el.parentNode === list ? el : item;
      }
      var rows = items.map(function (item) {
        return {
          target: flexChild(item),
          cat: (item.getAttribute('data-faq-category') || '').trim()
        };
      });

      var cats = [];
      rows.forEach(function (row) {
        if (row.cat && cats.indexOf(row.cat) === -1) cats.push(row.cat);
      });
      if (cats.length < 2) return; // Nothing to filter between.

      function select(cat) {
        rows.forEach(function (row) {
          row.target.hidden = !!row.cat && row.cat !== cat;
        });
        Array.prototype.forEach.call(row.children, function (pill) {
          var on = pill.dataset.cat === cat;
          pill.classList.toggle('is-active', on);
          pill.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }

      cats.forEach(function (cat) {
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'faq-cats__pill';
        pill.setAttribute('role', 'tab');
        pill.dataset.cat = cat;
        pill.textContent = cat;
        pill.addEventListener('click', function () { select(cat); });
        row.appendChild(pill);
      });

      row.hidden = false;
      select(cats[0]);
    }

    function boot() {
      document.querySelectorAll('[data-faq-cats]').forEach(initFaqCats);
    }

    if (document.readyState !== 'loading') {
      boot();
    } else {
      document.addEventListener('DOMContentLoaded', boot);
    }
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["press-marquee"] && !Shopify.designMode) return;
  try {
    (function () {
    function initMarquee(el) {
      if (el.dataset.pmReady) return;
      var track = el.querySelector('[data-press-marquee-track]');
      if (!track) return;
      var items = track.children;
      if (items.length < 2) return; el.dataset.pmReady = 'true';
      var originals = Array.prototype.slice.call(items);
      originals.forEach(function (node) {
        var clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
      el.classList.add('is-animating');
    }
    function boot() {
      document.querySelectorAll('[data-press-marquee]').forEach(initMarquee);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-tabs"] && !Shopify.designMode) return;
  try {
    function wInitCarousels(root) {
    root.querySelectorAll('[data-w-carousel]').forEach((el) => {
      if (el.dataset.wReady) return;
      el.dataset.wReady = 'true';
      const highlights = el.dataset.layout === 'highlights';
      const scope = el.closest('.w-tab__panel') || el.parentElement || el;
      const options = {
        loop: false,
        slidesPerView: 2,
        spaceBetween: 6,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        scrollbar: { el: scope.querySelector('.w-carousel__bar'), draggable: true },
        breakpoints: {
          750: { slidesPerView: 3, spaceBetween: 6 },
          990: { slidesPerView: highlights ? 'auto' : 4, spaceBetween: 12 },
        },
      };
      const prev = scope.querySelector('.w-carousel__nav--prev');
      const next = scope.querySelector('.w-carousel__nav--next');
      if (prev && next) options.navigation = { prevEl: prev, nextEl: next };
      el.wSwiper = new Swiper(el, options);
    });
  }

  function wRefreshPanel(panel) {
    panel.querySelectorAll('[data-w-carousel]').forEach((el) => {
      if (el.wSwiper) el.wSwiper.update();
    });
  }

  function wHighlightsLayout(tabs) {
    const section = tabs.closest('.w-products--highlights');
    if (!section) return;
    const blocks = section.querySelector('.w-products__blocks');
    const panelsRoot = tabs.querySelector(':scope > .w-tabs__panels');
    const nav = tabs.querySelector(':scope > .w-tabs__nav') || tabs.wNav;
    if (!blocks || !nav || !panelsRoot) return;
    tabs.wNav = nav;

    const desktop = window.matchMedia('(min-width: 990px)').matches;
    const tabsWrap = tabs.closest('.shopify-block');

    const titleBlock = blocks.querySelector(':scope > .shopify-block > .text-block');
    const titleWrap = titleBlock ? titleBlock.parentElement : null;
    if (titleWrap) {
      if (desktop) {
        if (nav.parentElement !== titleWrap) titleWrap.appendChild(nav);
      } else if (nav.parentElement !== tabs) {
        tabs.insertBefore(nav, panelsRoot);
      }
    }

    const promo = section.querySelector('.w-promo');
    const promoWrap = promo ? promo.parentElement : null;
    if (!promoWrap) return;

    const activePanel =
      panelsRoot.querySelector(':scope > .is-active') || panelsRoot.firstElementChild;
    const track = desktop && activePanel ? activePanel.querySelector('.swiper-wrapper') : null;

    if (track) {
      promoWrap.classList.add('swiper-slide', 'w-carousel__slide', 'w-carousel__slide--promo');
      if (track.firstElementChild !== promoWrap) track.insertBefore(promoWrap, track.firstElementChild);
    } else {
      promoWrap.classList.remove('swiper-slide', 'w-carousel__slide', 'w-carousel__slide--promo');
      if (tabsWrap && promoWrap.nextElementSibling !== tabsWrap) {
        blocks.insertBefore(promoWrap, tabsWrap);
      }
    }
  }

  function wUpdateCarousels(root) {
    root.querySelectorAll('[data-w-carousel]').forEach((el) => {
      if (el.wSwiper) el.wSwiper.update();
    });
  }

  function wBindTabs(tabs) {
    if (tabs.dataset.wTabsBound) return;
    tabs.dataset.wTabsBound = 'true';

    const nav = tabs.querySelector(':scope > .w-tabs__nav');
    const panelsRoot = tabs.querySelector(':scope > .w-tabs__panels');
    if (!nav || !panelsRoot) return;
    const panels = Array.from(panelsRoot.children);
    if (!panels.length) return;

    const pills = [];
    let initial = 0;
    panels.forEach((panel, i) => {
      const inner = panel.querySelector('[data-w-tab-label]') || panel;
      const label = inner.getAttribute('data-w-tab-label') || '';
      if (inner.getAttribute('data-w-tab-active') === 'true') initial = i;
      const pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'w-tabs__pill';
      pill.setAttribute('role', 'tab');
      pill.textContent = label;
      nav.appendChild(pill);
      pills.push(pill);
    });
    nav.hidden = panels.length < 2;

    function select(index) {
      pills.forEach((pill, i) => {
        const on = i === index;
        pill.classList.toggle('is-active', on);
        pill.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach((panel, i) => {
        const on = i === index;
        panel.classList.toggle('is-active', on);
        if (on) wRefreshPanel(panel);
      });
      tabs.dataset.active = String(index);
      wHighlightsLayout(tabs);
      wUpdateCarousels(tabs);
    }

    pills.forEach((pill, i) => {
      pill.addEventListener('click', () => select(i));
    });

    select(initial);
  }

  function wBootTabs() {
    document.querySelectorAll('[data-w-tabs]').forEach((tabs) => {
      wBindTabs(tabs);
      wHighlightsLayout(tabs);
      wInitCarousels(tabs);
    });
  }

  function wWatchBreakpoint() {
    const mq = window.matchMedia('(min-width: 990px)');
    const onChange = () => {
      document.querySelectorAll('[data-w-tabs]').forEach((tabs) => {
        wHighlightsLayout(tabs);
        wUpdateCarousels(tabs);
      });
    };
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', onChange);
    else if (typeof mq.addListener === 'function') mq.addListener(onChange);
  }

  function wWhenSwiper(run) {
    if (typeof Swiper !== 'undefined') {
      run();
      return;
    }
    let tries = 0;
    const timer = setInterval(() => {
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        run();
      } else if (++tries > 100) {
        clearInterval(timer);
      }
    }, 50);
  }

  function wReady(run) {
    if (document.readyState !== 'loading') {
      run();
    } else {
      document.addEventListener('DOMContentLoaded', run);
    }
  }

  wReady(() => {
    wWatchBreakpoint();
    wWhenSwiper(wBootTabs);
  });
  document.addEventListener('shopify:section:load', () => wWhenSwiper(wBootTabs));
  document.addEventListener('shopify:block:select', () => wWhenSwiper(wBootTabs));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["reviews-badge"] && !Shopify.designMode) return;
  try {
    (function () {
    var CIBLES = ['.section--reviews-app', '.section--apps', '.section--reviews'];

    function trouverCible() {
      for (var i = 0; i < CIBLES.length; i++) {
        var el = document.querySelector(CIBLES[i]);
        if (el) return el;
      }
      return null;
    }

    function boot() {
      var target = trouverCible();
      if (!target) return;

      document.querySelectorAll('[data-reviews-link]').forEach(function (badge) {
        if (badge.dataset.wReady) return;
        badge.dataset.wReady = 'true';

        badge.classList.add('reviews-badge--clickable');
        badge.setAttribute('role', 'button');
        badge.setAttribute('tabindex', '0');
        if (!badge.getAttribute('aria-label')) {
          badge.setAttribute('aria-label', badge.textContent.replace(/\s+/g, ' ').trim());
        }

        function go() {
          var header = document.querySelector('.w-header');
          var offset = header ? header.getBoundingClientRect().height : 0;
          var y = target.getBoundingClientRect().top + window.pageYOffset - offset - 12;
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: y < 0 ? 0 : y, behavior: reduce ? 'auto' : 'smooth' });
        }

        badge.addEventListener('click', go);
        badge.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); }
        });
      });
    }

    if (document.readyState !== 'loading') { boot(); }
    else { document.addEventListener('DOMContentLoaded', boot); }
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
